var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#1A1D1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4889 17.0539C21.376 16.527 20.624 16.5269 20.5111 17.0539L19.3166 22.6284C19.0202 24.0116 17.7978 24.9998 16.3832 24.9998H15C14.4477 24.9998 14 24.5521 14 23.9998C14 23.4475 14.4477 22.9998 15 22.9998H16.3832C16.8547 22.9998 17.2622 22.6704 17.361 22.2093L18.5555 16.6349C19.1201 14 22.8799 14 23.4445 16.6349L26.5111 30.9456C26.624 31.4726 27.376 31.4726 27.4889 30.9456L28.6834 25.3712C28.9798 23.988 30.2022 22.9998 31.6168 22.9998H33C33.5523 22.9998 34 23.4475 34 23.9998C34 24.5521 33.5523 24.9998 33 24.9998H31.6168C31.1453 24.9998 30.7378 25.3292 30.639 25.7902L29.4445 31.3647C28.8799 33.9996 25.1201 33.9996 24.5555 31.3647L21.4889 17.0539Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningIcon);
export default __webpack_public_path__ + "static/media/Earning_Icon.15756e155b5a243c175c5d16fbc3748f.svg";
export { ForwardRef as ReactComponent };